import { MenuComponent } from './menu/menu.component';
import { SettingsComponent } from './settings.component';
import { SharedModule } from './../../shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateTimeFormatConfigModule } from '../../date-time-format-config/date-time-format-config.module';

const routes: Routes = [
  {
    path: '', component: SettingsComponent
  }
]

@NgModule({
  declarations: [SettingsComponent, MenuComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    DateTimeFormatConfigModule
  ],
  exports: [
    SettingsComponent
  ]
})
export class SettingsModule { }
